export const serviceStock = {
    id: 'service-stock',
    schemaVersion: 2,
    covers: "A day's timetable: four times of day, each with one clip. Suits 'a day at the clinic' or an opening-hours idea, not an explanation.",
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 147,
    },
    root: {
        kind: 'split',
        axis: 'v',
        children: [
            {
                ratio: 1,
                region: {
                    kind: 'leaf',
                    id: 'pane-1',
                    spine: [
                        {
                            kind: 'media-track',
                            id: 'pane-1-broll',
                            duration: {
                                kind: 'fill',
                            },
                            clips: {
                                source: 'query',
                                query: {
                                    kind: 'asset-clips',
                                    tag: 'environment',
                                    count: [1, 1],
                                },
                                required: true,
                            },
                            fit: 'cover',
                            clipOffset: 0,
                            cuts: {
                                mode: 'at',
                                at: [
                                    {
                                        atSec: 0,
                                        transition: 'cut',
                                    },
                                ],
                            },
                        },
                    ],
                    overlays: [
                        {
                            kind: 'text',
                            id: 'pane-1-time',
                            duration: {
                                kind: 'fill',
                            },
                            text: {
                                source: 'query',
                                query: {
                                    kind: 'content',
                                    field: 'time1',
                                },
                                required: true,
                            },
                            style: 'display',
                            styleOverride: {
                                color: '#FBF7B0',
                                textTransform: 'none',
                                fontRef: 'playfair-light',
                                fontSize: 72,
                                fontWeight: 300,
                                whiteSpace: 'nowrap',
                            },
                            animation: {
                                entrance: 'none',
                            },
                            placement: {
                                anchor: 'center',
                                x: 0.5,
                                y: 0.5,
                                width: 0.9,
                            },
                        },
                    ],
                },
            },
            {
                ratio: 1,
                region: {
                    kind: 'leaf',
                    id: 'pane-2',
                    spine: [
                        {
                            kind: 'media-track',
                            id: 'pane-2-broll',
                            duration: {
                                kind: 'fill',
                            },
                            clips: {
                                source: 'query',
                                query: {
                                    kind: 'asset-clips',
                                    tag: 'procedure',
                                    count: [1, 1],
                                },
                                required: true,
                            },
                            fit: 'cover',
                            clipOffset: 1,
                            cuts: {
                                mode: 'at',
                                at: [
                                    {
                                        atSec: 0,
                                        transition: 'cut',
                                    },
                                ],
                            },
                        },
                    ],
                    overlays: [
                        {
                            kind: 'text',
                            id: 'pane-2-time',
                            duration: {
                                kind: 'fill',
                            },
                            text: {
                                source: 'query',
                                query: {
                                    kind: 'content',
                                    field: 'time2',
                                },
                                required: true,
                            },
                            style: 'display',
                            styleOverride: {
                                color: '#FBF7B0',
                                textTransform: 'none',
                                fontRef: 'playfair-light',
                                fontSize: 72,
                                fontWeight: 300,
                                whiteSpace: 'nowrap',
                            },
                            animation: {
                                entrance: 'none',
                            },
                            placement: {
                                anchor: 'center',
                                x: 0.5,
                                y: 0.5,
                                width: 0.9,
                            },
                        },
                    ],
                },
            },
            {
                ratio: 1,
                region: {
                    kind: 'leaf',
                    id: 'pane-3',
                    spine: [
                        {
                            kind: 'media-track',
                            id: 'pane-3-broll',
                            duration: {
                                kind: 'fill',
                            },
                            clips: {
                                source: 'query',
                                query: {
                                    kind: 'asset-clips',
                                    tag: 'environment',
                                    count: [1, 1],
                                },
                                required: true,
                            },
                            fit: 'cover',
                            clipOffset: 2,
                            cuts: {
                                mode: 'at',
                                at: [
                                    {
                                        atSec: 0,
                                        transition: 'cut',
                                    },
                                ],
                            },
                        },
                    ],
                    overlays: [
                        {
                            kind: 'text',
                            id: 'pane-3-time',
                            duration: {
                                kind: 'fill',
                            },
                            text: {
                                source: 'query',
                                query: {
                                    kind: 'content',
                                    field: 'time3',
                                },
                                required: true,
                            },
                            style: 'display',
                            styleOverride: {
                                color: '#FBF7B0',
                                textTransform: 'none',
                                fontRef: 'playfair-light',
                                fontSize: 72,
                                fontWeight: 300,
                                whiteSpace: 'nowrap',
                            },
                            animation: {
                                entrance: 'none',
                            },
                            placement: {
                                anchor: 'center',
                                x: 0.5,
                                y: 0.5,
                                width: 0.9,
                            },
                        },
                    ],
                },
            },
            {
                ratio: 1,
                region: {
                    kind: 'leaf',
                    id: 'pane-4',
                    spine: [
                        {
                            kind: 'media-track',
                            id: 'pane-4-broll',
                            duration: {
                                kind: 'fill',
                            },
                            clips: {
                                source: 'query',
                                query: {
                                    kind: 'asset-clips',
                                    tag: 'procedure',
                                    count: [1, 1],
                                },
                                required: true,
                            },
                            fit: 'cover',
                            clipOffset: 3,
                            cuts: {
                                mode: 'at',
                                at: [
                                    {
                                        atSec: 0,
                                        transition: 'cut',
                                    },
                                ],
                            },
                        },
                    ],
                    overlays: [
                        {
                            kind: 'text',
                            id: 'pane-4-time',
                            duration: {
                                kind: 'fill',
                            },
                            text: {
                                source: 'query',
                                query: {
                                    kind: 'content',
                                    field: 'time4',
                                },
                                required: true,
                            },
                            style: 'display',
                            styleOverride: {
                                color: '#FBF7B0',
                                textTransform: 'none',
                                fontRef: 'playfair-light',
                                fontSize: 72,
                                fontWeight: 300,
                                whiteSpace: 'nowrap',
                            },
                            animation: {
                                entrance: 'none',
                            },
                            placement: {
                                anchor: 'center',
                                x: 0.5,
                                y: 0.5,
                                width: 0.9,
                            },
                        },
                    ],
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        time1: {
            type: 'text',
            maxChars: 12,
            description: "Time of the first step of the day, e.g. '11:00 am'. One line.",
        },
        time2: {
            type: 'text',
            maxChars: 12,
            description: 'Time of the second step, later than the first. One line.',
        },
        time3: {
            type: 'text',
            maxChars: 12,
            description: 'Time of the third step, later than the second. One line.',
        },
        time4: {
            type: 'text',
            maxChars: 12,
            description: 'Time of the fourth step, later than the third. One line.',
        },
    },
    structure: 'Four times of day, in order, one per panel — a timetable and nothing else. No sentences, no claims, no service names. The source is exactly: "11:00 am / 11:30 am / 12:00 pm / 12:15 pm".',
};
//# sourceMappingURL=service-stock.js.map